import { render, staticRenderFns } from "./CarContentCheckbox.vue?vue&type=template&id=656f2aa2&"
import script from "./CarContentCheckbox.vue?vue&type=script&lang=js&"
export * from "./CarContentCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports